'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_product from './tpl/product.html';
import language from '../../../common/language';
import config from '../../../common/config';

export default Marionette.ItemView.extend({
    getTemplate: function () {
        return tpl_product({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;
    },
    ui: {
        'product_btnAddCart' : '#product_btnAddCart',
        'product_inputQty' :'#product_inputQty',
        'product_image01' : '#product_image01',
        'product_image02' : '#product_image02',
        'product_image03' : '#product_image03',
        'product_image04' : '#product_image04',
        'product_imageMain' : '#product_imageMain'
    },
    events: {
        'click @ui.product_btnAddCart': 'btnAddCart',
        'click @ui.product_image01': 'image01Clicked',
        'click @ui.product_image02': 'image02Clicked',
        'click @ui.product_image03': 'image03Clicked',
        'click @ui.product_image04': 'image04Clicked'
    },
    onRender: function () {
    },
    btnAddCart: function (event) {
        event.preventDefault();

        var userChannel = Backbone.Radio.channel('app');
        this.model.attributes.TempQty = parseInt(this.ui.product_inputQty[0].value)
        userChannel.trigger('menu:shopAddToCart', this.model);
    },
    image01Clicked: function (event) {
        event.preventDefault();
        this.ui.product_imageMain.attr('src',this.model.attributes.Image01);

    },
    image02Clicked: function (event) {
        event.preventDefault();
        this.ui.product_imageMain.attr('src',this.model.attributes.Image02);

    },
    image03Clicked: function (event) {
        event.preventDefault();
        this.ui.product_imageMain.attr('src',this.model.attributes.Image03);

    },
    image04Clicked: function (event) {
        event.preventDefault();
        this.ui.product_imageMain.attr('src',this.model.attributes.Image04);

    }
}, Backbone.Radio.Requests);